import { Box, Flex, Heading, Text, Tag, VStack, useColorModeValue, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";

interface DeliverablesProps {
    deliverables : { title: string; icon: IconType; description: string; tags:string[]; }[];
    
}
const DeliverablesSection = ({deliverables} : DeliverablesProps) => {
  const accentColor = useColorModeValue("blue.500", "blue.300");
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  

  return (
    <Box 
      as="section" 
      py={12} 
      bg={useColorModeValue("gray.50", "gray.700")}
      borderRadius="xl"
      mt={10}
    >
      <VStack spacing={6} maxW="6xl" mx="auto" px={{ base: 4, md: 8 }}>
        <Heading 
          size="xl" 
          textAlign="center"
          bgGradient="linear(to-r, blue.400, purple.600)"
          bgClip="text"
        >
          Deliverables You Receive
        </Heading>
        
        <Text 
          fontSize="lg" 
          textAlign="center" 
          maxW="3xl"
          color={useColorModeValue("gray.600", "gray.300")}
        >
          Concrete tools and artifacts to operationalize your scaling strategy
        </Text>

        <Flex 
          wrap="wrap" 
          justify="center" 
          gap={6} 
          mt={8}
          w="full"
        >
          {deliverables.map((item, index) => (
            <Box
              key={index}
              p={6}
              borderWidth="1px"
              borderColor={borderColor}
              borderRadius="xl"
              bg={cardBg}
              flex={{ base: "1 1 100%", md: "1 1 45%", lg: "1 1 22%" }}
              minW={{ base: "full", md: "300px" }}
              transition="all 0.2s ease"
              _hover={{
                transform: "translateY(-5px)",
                boxShadow: "lg",
                borderColor: accentColor
              }}
            >
              <VStack spacing={4} align="start" h="full">
                <Icon 
                  as={item.icon} 
                  boxSize={6} 
                  color={accentColor} 
                  mb={2}
                />
                <Heading size="md">{item.title}</Heading>
                <Text flex="1">{item.description}</Text>
                <Flex wrap="wrap" gap={2} pt={2}>
                  {item.tags.map((tag, tagIndex) => (
                    <Tag 
                      key={tagIndex} 
                      colorScheme="blue" 
                      variant="subtle"
                      size="sm"
                    >
                      {tag}
                    </Tag>
                  ))}
                </Flex>
              </VStack>
            </Box>
          ))}
        </Flex>
      </VStack>
    </Box>
  );
};

export default DeliverablesSection;